import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import ImageLayer from 'ol/layer/Image';
import Tile from 'ol/layer/Tile';
import Zoom from 'ol/control/Zoom';
import Attribution from 'ol/control/Attribution';
import TileWMS from 'ol/source/TileWMS';
import ImageWMS from 'ol/source/ImageWMS';
import Vector from 'ol/source/Vector';
import { fromLonLat } from 'ol/proj';
import Geolocation from 'ol/Geolocation';
import BingMaps from 'ol/source/BingMaps';
import OSM from 'ol/source/OSM';
import MousePosition from 'ol/control/MousePosition';
import { defaults as defaultControls } from 'ol/control';
import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Circle from 'ol/style/Circle';
import $ from 'jQuery';
// import jqueryui from 'jquery-ui'
// import 'jquery-ui-touch-punch';
import { defaults } from 'ol/interaction';
import { createStringXY } from 'ol/coordinate';
import { containsCoordinate } from 'ol/extent';
import SlideRuler from 'slide-ruler';
// import Projection from 'ol/proj/Projection';
// import {register} from 'ol/proj/proj4';
// import proj4 from 'proj4';

// proj4.defs('EPSG:3014',
//  '+proj=tmerc +lat_0=0 +lon_0=17.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs');
// register(proj4);

// 'use strict';
// let $ = require('jQuery');
// global.jQuery = global.$ = $;

// $.ui = require('jQuery-ui');
// $.ui.touch = require("jQuery-ui-touch-punch");

global.baseLayersArray = [];
global.topLayersArray = [];
global.baseLayersArrayLength;
global.topLayersArrayLength;
// var baseLayersArray = [];
// var topLayersArray = [];
// var baseLayersArrayLength;
// var topLayersArrayLength;

//  	if ($.browser.msie && parseInt($.browser.version, 10) < 9) {
//  		window.alert("Du använder en gammal webbläsare som inte stöds.");
//  		document.execCommand('Stop');
//  		window.stop();
//  	}
  	$(document).ready(() => {
  	resizeDiv();
  	});

  	window.onresize = function (event) {
  	resizeDiv();
  	};

  	function resizeDiv() {
  	const vpw = $(window).width();
  	const vph = $(window).height();
  	$('#map').css({ height: `${vph}px`, width: `${vpw}px` });
  	}

// Show the dropdown menu
$(document.body).on('click', '.dropbtn', (e) => {
  document.getElementById('dropdown-menu').classList.toggle('show-dropdown');
});

// Hide the rulers if not on a touch device
if ('ontouchstart' in document.documentElement) {
  // console.log("your device is a touch screen device.");
} else {
  // console.log("your device is NOT a touch device");
  document.getElementById('ruler-transparency').style.display = 'none';
  document.getElementById('ruler-size').style.display = 'none';
}

const key = 'Ah4C9Ite0bCpmz4Iu0MExgvuIfjpvEiQt06FTP_qBXjFptMM5WA9wPVp_WZfzfOr';
const extent = [1781111.8, 8859142.8, 2003750.8, 9349764.1];
const geoserverUrl = 'https://karta.sundsvall.se/geoserver/wms';
const geoserverUrl_test = 'https://kartatest.sundsvall.se/geoserver/wms';

const attribution = new Attribution({ className: 'ol-attribution' });
const mapControls = [
  new Zoom({
    zoomInTipLabel: 'zooma in', zoomOutTipLabel: 'zooma ut', zoomInLabel: '', zoomOutLabel: ''
  }),
  attribution
];
const interactions = defaults({ altShiftDragRotate: false, pinchRotate: false });

// alert(fromLonLat([16, 63]));
const roads = new TileLayer({
  source: new BingMaps({ key, imagerySet: 'RoadOnDemand' })
});

const osm = new Tile({
  source: new OSM({ attributions: '&copy; OpenStreetMap contributors' })
});

const ol_osm = new Tile({
  source: new OSM({ attributions: '&copy; OpenStreetMap contributors' })
});

// create a base vector layer that will show search results.
const baseSearchLayer = new Vector({
  name: 'search_layer',
  source: new Vector(),
  style: new Style({
    fill: new Fill({
      color: 'rgba(27, 120, 204, 0.3)'
    }),
    stroke: new Stroke({
      color: '#000000',
      width: 2
    }),
    image: new Circle({
      radius: 7,
      fill: new Fill({
        color: '#1b78cc'
      })
    })
  })
});

// configure the layers that will be searched.
const searchLayers = [
  {
    id: 's01',
    caption: 'Adress',
    url: geoserverUrl,
    layer: 'Lantmateriet:Adresser_wms',
    searchField: 'sok',
    displayFields: ['sok'],
    geometryField: 'geom',
    outputFormat: 'GML2'
  },
  {
    id: 's02',
    caption: 'Fastighet',
    url: geoserverUrl,
    layer: 'Lantmateriet:fastighet_granser',
    searchField: 'text',
    displayFields: ['text'],
    geometryField: 'geom',
    outputFormat: 'GML2'
  }
];

const topo = new Tile({
  extent,
  source: new TileWMS({
    attributions: '&copy; Lantmäteriet Geodatasamverkan',
	  url: geoserverUrl,
	  params: { LAYERS: 'Lantmateriet:topowebbkartan', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
	  transition: 0
  })
});

const ol_topo = new Tile({
  extent,
  source: new TileWMS({
    attributions: '&copy; Lantmäteriet Geodatasamverkan',
	  url: geoserverUrl,
    params: { LAYERS: 'Lantmateriet:topowebbkartan', VERSION: '1.1.1', TILED: true },
    serverType: 'geoserver',
    transition: 0
  })
});

const orto1960 = new Tile({
  extent,
  source: new TileWMS({
    attributions: '1960 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: { LAYERS: 'Lantmateriet:HistoriskaOrtofoton1960_wms', VERSION: '1.1.1', TILED: true },
    serverType: 'geoserver',
    transition: 0
  })
});

const ol_orto1960 = new Tile({
  extent,
  source: new TileWMS({
    attributions: '1960 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: { LAYERS: 'Lantmateriet:HistoriskaOrtofoton1960_wms', VERSION: '1.1.1', TILED: true },
    serverType: 'geoserver',
    transition: 0
  })
});

const orto1975 = new Tile({
  extent,
  source: new TileWMS({
    attributions: '1975 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: { LAYERS: 'Lantmateriet:HistoriskaOrtofoton1975_wms', VERSION: '1.1.1', TILED: true },
    serverType: 'geoserver',
    transition: 0
  })
});

const ol_orto1975 = new Tile({
  extent,
  source: new TileWMS({
    attributions: '1975 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: { LAYERS: 'Lantmateriet:HistoriskaOrtofoton1975_wms', VERSION: '1.1.1', TILED: true },
    serverType: 'geoserver',
    transition: 0
  })
});

const orto2007 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '2007 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: { LAYERS: 'Lantmateriet:Orto2007_wms', VERSION: '1.1.1', TILED: true },
    serverType: 'geoserver',
    transition: 0
  })
});

const ol_orto2007 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '2007 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: { LAYERS: 'Lantmateriet:Orto2007_wms', VERSION: '1.1.1', TILED: true },
    serverType: 'geoserver',
    transition: 0
  })
});

const orto2010 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '2010 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: { LAYERS: 'Lantmateriet:Orto2010_wms', VERSION: '1.1.1', TILED: true },
    serverType: 'geoserver',
    transition: 0
  })
});

const ol_orto2010 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '2010 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: { LAYERS: 'Lantmateriet:Orto2010_wms', VERSION: '1.1.1', TILED: true },
    serverType: 'geoserver',
    transition: 0
  })
});

const orto2013 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '2013 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: { LAYERS: 'Lantmateriet:Orto2013_wms', VERSION: '1.1.1', TILED: true },
    serverType: 'geoserver',
    transition: 0
  })
});

const ol_orto2013 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '2013 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: { LAYERS: 'Lantmateriet:Orto2013_wms', VERSION: '1.1.1', TILED: true },
    serverType: 'geoserver',
    transition: 0
  })
});

const orto2015 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '2015 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: { LAYERS: 'Lantmateriet:Orto2015_wms', VERSION: '1.1.1', TILED: true },
    serverType: 'geoserver',
    transition: 0
  })
});

const ol_orto2015 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '2015 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: { LAYERS: 'Lantmateriet:Orto2015_wms', VERSION: '1.1.1', TILED: true },
    serverType: 'geoserver',
    transition: 0
  })
});

const orto2017 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '2017 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: { LAYERS: 'Lantmateriet:Orto2017_wms', VERSION: '1.1.1', TILED: true },
    serverType: 'geoserver',
    transition: 0
  })
});

const ol_orto2017 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '2017 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: { LAYERS: 'Lantmateriet:Orto2017_wms', VERSION: '1.1.1', TILED: true },
    serverType: 'geoserver',
    transition: 0
  })
});

const orto2019 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '2019 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: { LAYERS: 'Lantmateriet:Orto2019_wms', VERSION: '1.1.1', TILED: true },
    serverType: 'geoserver',
    transition: 0
  })
});

const ol_orto2019 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '2019 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: { LAYERS: 'Lantmateriet:Orto2019_wms', VERSION: '1.1.1', TILED: true },
    serverType: 'geoserver',
    transition: 0
  })
});

const orto2021 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '2021 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: { LAYERS: 'Lantmateriet:Orto2021_wms', VERSION: '1.1.1', TILED: true },
    serverType: 'geoserver',
    transition: 0
  })
});

const ol_orto2021 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '2021 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: { LAYERS: 'Lantmateriet:Orto2021_wms', VERSION: '1.1.1', TILED: true },
    serverType: 'geoserver',
    transition: 0
  })
});

const lmorto = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '2023 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
	  url: geoserverUrl,
	  params: { LAYERS: 'Lantmateriet:Ortofoto50_25cm', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
	  transition: 0
  })
});

const ol_lmorto = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '2023 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
	  url: geoserverUrl,
	  params: { LAYERS: 'Lantmateriet:Ortofoto50_25cm', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
	  transition: 0
  })
});

const lutning = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: 'Laserdata NH: &copy; Lantmäteriet',
	  url: geoserverUrl,
	  params: { LAYERS: 'Lantmateriet:terranglutning', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
	  transition: 0
  })
});

const ol_lutning = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: 'Laserdata NH: &copy; Lantmäteriet Geodatasamverkan',
	  url: geoserverUrl,
	  params: { LAYERS: 'Lantmateriet:terranglutning', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
	  transition: 0
  })
});

const skugg = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: 'Laserdata NH: &copy; Lantmäteriet Geodatasamverkan',
	  url: geoserverUrl,
	  params: { LAYERS: 'Lantmateriet:terrangskuggning_wms', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
	  transition: 0
  })
});

const ol_skugg = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: 'Laserdata NH: &copy; Lantmäteriet Geodatasamverkan',
  	url: geoserverUrl,
	  params: { LAYERS: 'Lantmateriet:terrangskuggning_wms', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
	  transition: 0
  })
});

const friluft = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
	  url: geoserverUrl,
	  params: { LAYERS: 'Friluftskarta', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
	  transition: 0
  })
});

const ol_friluft = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
	  url: geoserverUrl,
	  params: { LAYERS: 'Friluftskarta', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
	  transition: 0
  })
});

const detalj = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
	  url: geoserverUrl,
	  params: { LAYERS: 'SundsvallsKommun:detaljplan_mosaik', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
	  transition: 0
  })
});

const ol_detalj = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
	  url: geoserverUrl,
	  params: { LAYERS: 'SundsvallsKommun:detaljplan_mosaik', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
	  transition: 0
  })
});

const hist1642 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: { LAYERS: 'SundsvallsKommun:HistoriskKarta1642', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

const ol_hist1642 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: { LAYERS: 'SundsvallsKommun:HistoriskKarta1642', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

const hist1857 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: { LAYERS: 'SundsvallsKommun:HistoriskKarta1857', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

const ol_hist1857 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: { LAYERS: 'SundsvallsKommun:HistoriskKarta1857', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

const hist1878 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: { LAYERS: 'SundsvallsKommun:HistoriskKarta1878', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

const ol_hist1878 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: { LAYERS: 'SundsvallsKommun:HistoriskKarta1878', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

const hist1910 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: { LAYERS: 'SundsvallsKommun:HistoriskKarta1910', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

const ol_hist1910 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: { LAYERS: 'SundsvallsKommun:HistoriskKarta1910', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

const hist1917 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: { LAYERS: 'SundsvallsKommun:HistoriskKarta1917', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

const ol_hist1917 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: { LAYERS: 'SundsvallsKommun:HistoriskKarta1917', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

const hist1935 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: { LAYERS: 'SundsvallsKommun:HistoriskKarta1935', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

const ol_hist1935 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: { LAYERS: 'SundsvallsKommun:HistoriskKarta1935', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

const hist1939 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: { LAYERS: 'SundsvallsKommun:HistoriskKarta1939', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

const ol_hist1939 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: { LAYERS: 'SundsvallsKommun:HistoriskKarta1939', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

const hist1952 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: { LAYERS: 'SundsvallsKommun:HistoriskKarta1952', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

const ol_hist1952 = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: { LAYERS: 'SundsvallsKommun:HistoriskKarta1952', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

const ekonomiska = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: 'Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: { LAYERS: 'Lantmateriet:EkonomiskaKartan', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

const ol_ekonomiska = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: 'Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: { LAYERS: 'Lantmateriet:EkonomiskaKartan', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

const general = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: 'Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: { LAYERS: 'Lantmateriet:Generalstabskartan', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

const ol_general = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: 'Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: { LAYERS: 'Lantmateriet:Generalstabskartan', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

const laga = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: 'Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: { LAYERS: 'SundsvallsKommun:LagaSkifteskartor_mosaik', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

const ol_laga = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: 'Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: { LAYERS: 'SundsvallsKommun:LagaSkifteskartor_mosaik', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

const orientering = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '&copy; Njurunda OK',
    url: geoserverUrl_test,
    params: { LAYERS: 'SundsvallsKommun:OrienteringNjurunda', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
    projection: 'EPSG:3006',
	  transition: 0
  })
});

const ol_orientering = new TileLayer({
  extent,
  source: new TileWMS({
    attributions: '&copy; Njurunda OK',
    url: geoserverUrl_test,
    params: { LAYERS: 'SundsvallsKommun:OrienteringNjurunda', VERSION: '1.1.1', TILED: true },
	  serverType: 'geoserver',
    projection: 'EPSG:3006',
	  transition: 0
  })
});

baseLayersArray.push(topo);
baseLayersArray.push(friluft);
baseLayersArray.push(osm);
baseLayersArray.push(orto1960);
baseLayersArray.push(orto1975);
baseLayersArray.push(orto2007);
baseLayersArray.push(orto2010);
baseLayersArray.push(orto2013);
baseLayersArray.push(orto2015);
baseLayersArray.push(orto2017);
baseLayersArray.push(orto2019);
baseLayersArray.push(orto2021);
baseLayersArray.push(lmorto);
baseLayersArray.push(lutning);
baseLayersArray.push(skugg);
baseLayersArray.push(detalj);
baseLayersArray.push(hist1642);
baseLayersArray.push(hist1857);
baseLayersArray.push(hist1878);
baseLayersArray.push(hist1910);
baseLayersArray.push(hist1917);
baseLayersArray.push(hist1935);
baseLayersArray.push(hist1939);
baseLayersArray.push(hist1952);
baseLayersArray.push(ekonomiska);
baseLayersArray.push(general);
baseLayersArray.push(laga);
// baseLayersArray.push(orientering);

topLayersArray.push(ol_topo);
topLayersArray.push(ol_friluft);
topLayersArray.push(ol_osm);
topLayersArray.push(ol_orto1960);
topLayersArray.push(ol_orto1975);
topLayersArray.push(ol_orto2007);
topLayersArray.push(ol_orto2010);
topLayersArray.push(ol_orto2013);
topLayersArray.push(ol_orto2015);
topLayersArray.push(ol_orto2017);
topLayersArray.push(ol_orto2019);
topLayersArray.push(ol_orto2021);
topLayersArray.push(ol_lmorto);
topLayersArray.push(ol_lutning);
topLayersArray.push(ol_skugg);
topLayersArray.push(ol_detalj);
topLayersArray.push(ol_hist1642);
topLayersArray.push(ol_hist1857);
topLayersArray.push(ol_hist1878);
topLayersArray.push(ol_hist1910);
topLayersArray.push(ol_hist1917);
topLayersArray.push(ol_hist1935);
topLayersArray.push(ol_hist1939);
topLayersArray.push(ol_hist1952);
topLayersArray.push(ol_ekonomiska);
topLayersArray.push(ol_general);
topLayersArray.push(ol_laga);
// topLayersArray.push(ol_orientering);

const imagery = new Tile({
  source: new BingMaps({ key, imagerySet: 'Aerial' })
});

const container = document.getElementById('map');

// create the map object
const map = new Map({
  layers: baseLayersArray.concat(topLayersArray),
  target: container,
  // controls: mapControls,
  interactions,
  loadTilesWhileAnimating: true,
  loadTilesWhileInteracting: true,
  view: new View({
    center: fromLonLat([17.3, 62.4]),
    extent,
    zoom: 13
  })
});

const baseLayersArrayLength = baseLayersArray.length;

for (var i = 0; i < baseLayersArrayLength; i++) {
  baseLayersArray[i].setVisible(false);
}

const topLayersArrayLength = topLayersArray.length;

for (var i = 0; i < topLayersArrayLength; i++) {
  topLayersArray[i].setVisible(false);

  // before rendering the layer, do some clipping
  topLayersArray[i].on('prerender', (event) => {
    const ctx = event.context;
    const pixelRatio = event.frameState.pixelRatio;
    ctx.save();
    ctx.beginPath();
    if (mousePosition) {
      // only show a circle around the mouse
      ctx.arc(
        mousePosition[0] * pixelRatio,
        mousePosition[1] * pixelRatio,
        radius * pixelRatio,
        0,
        2 * Math.PI
      );
      ctx.lineWidth = 5 * pixelRatio;
      ctx.strokeStyle = 'rgba(0,0,0,0.5)';
      ctx.stroke();
    }
    ctx.clip();
  });

  // after rendering the layer, restore the canvas context
  topLayersArray[i].on('postrender', (event) => {
    const ctx = event.context;
    ctx.restore();
  });
}

topo.setVisible(true);
ol_orto1960.setVisible(true);

const view = map.getView();
const minZoom = view.getMinZoom();
const maxZoom = view.getMaxZoom();

var radius = 130;
// Change the size of the circle for the peephole
document.addEventListener('keydown', (e) => {
  if (e.isComposing || e.keyCode === 229) {
    return;
  }
  if (e.keyCode === 38) {
    radius = Math.min(radius + 5, 500);
    map.render();
  } else if (e.keyCode === 40) {
    radius = Math.max(radius - 5, 25);
    map.render();
  }
});

// Change the transparency of the circle for the peephole
document.addEventListener('keydown', (evt) => {
  const layer = document.getElementById('select2').value;
  let opacity = topLayersArray[layer].getOpacity();
  if (evt.which === 37 && opacity > 0) {
    opacity = (opacity * 10 - 0.1 * 10) / 10;
    topLayersArray[layer].setOpacity(opacity);
  } else if (evt.which === 39 && opacity < 1) {
    opacity = (opacity * 10 + 0.1 * 10) / 10;
    topLayersArray[layer].setOpacity(opacity);
  }
  // $( "#slider-vertical" ).slider("value", opacity);
});

$(document).on('mousewheel', (evt) => {
  evt.preventDefault();
  const layer = document.getElementById('select2').value;
  let opacity = topLayersArray[layer].getOpacity();
  const delta = evt.originalEvent.wheelDelta;
  const mouseCoordinate = map.getEventCoordinate(evt.originalEvent);
  if (evt.shiftKey) {
    if (delta >= 0 && opacity < 1) {
      opacity = (opacity * 10 + 0.1 * 10) / 10;
      topLayersArray[layer].setOpacity(opacity);
    } else if (delta < 0 && opacity > 0) {
      opacity = (opacity * 10 - 0.1 * 10) / 10;
      topLayersArray[layer].setOpacity(opacity);
    }
  } else {
    const zoom = view.getZoom();
    if (delta >= 0 && zoom < maxZoom) {
      view.animate({
        zoom: zoom + 1,
        anchor: mouseCoordinate,
        duration: 200
      });
    } else if (delta < 0 && zoom > minZoom) {
      view.animate({
        zoom: zoom - 1,
        anchor: mouseCoordinate,
        duration: 200
      });
    }
  }
  // $( "#slider-vertical" ).slider("value", opacity);
});

$('.ol-zoom-in, .ol-zoom-out').on('click', function () {
  $(this).blur();
});

// move the 'peephole' window according to the mouse location.
var mousePosition = null;
container.addEventListener('mousemove', (event) => {
  const x = event.clientX;
  const y = event.clientY;
  const elementTouchIsOver = document.elementFromPoint(x, y);
  mousePosition = map.getEventPixel(event);
  map.render();
});

container.addEventListener('mouseout', () => {
  mousePosition = null;
  map.render();
});

// move the 'peephole' window according to the touch location.
container.addEventListener('touchstart', (event) => {
  if (document.getElementById('ruler-transparency').style.display === 'none') {
    document.getElementById('ruler-transparency').style.display = 'block';
    document.getElementById('ruler-size').style.display = 'block';
  }
  const x = event.touches[0].clientX;
  const y = event.touches[0].clientY;
  console.log(`X: ${x} Y: ${y}`);
  const elementTouchIsOver = document.elementFromPoint(x, y);
  console.log(`Touch: ${elementTouchIsOver.id}`);

  mousePosition = map.getEventPixel(event);
  map.render();
});

container.addEventListener('touchout', () => {
  mousePosition = null;
  map.render();
});

const geolocation = new Geolocation({
  projection: view.getProjection()
});

const urlParams = new URLSearchParams(window.location.search);
const lat = urlParams.get('lat');
const lon = urlParams.get('lon');

if (lat !== null && lon !== null) {
  const bglayer = urlParams.get('bglayer');
  const peeklayer = urlParams.get('peeklayer');
  const zoom = urlParams.get('zoom');
  if (isInt(bglayer)) {
    document.getElementById('select1').selectedIndex = bglayer;
    changeLayer(null);
  }
  if (isInt(peeklayer)) {
    document.getElementById('select2').selectedIndex = peeklayer;
    changeOLLayer(null);
  }
  if (isFloat(lat) && isFloat(lon) && containsCoordinate(extent, fromLonLat([lon, lat]))) {
    view.setCenter(fromLonLat([lon, lat]));
  }
  if (isInt(zoom)) {
    view.setZoom(zoom);
  }
} else {
  geolocation.setTracking(true);

  geolocation.on('change:position', () => {
  	const coordinates = geolocation.getPosition();
    view.setCenter(coordinates);
    geolocation.setTracking(false);
  });

  window.onload = function () {
    document.getElementById('select1').selectedIndex = 0;
    document.getElementById('select2').selectedIndex = 3;
  };
}

function el(id) {
  return document.getElementById(id);
}

el('track').addEventListener('click', () => {
  geolocation.setTracking(true);
});

window.onclick = function (event) {
  if (!$(event.target).is('.dropbtn')) {
    $('.ol-viewport').blur();
    // var dropdownMenu = document.getElementById("dropdown-menu");
    // dropdownMenu.classList.remove("show-dropdown");
  }
  if ($('.panel').hasClass('active')) {
    $('.panel').toggle('fast');
    $('.panel').toggleClass('active');
  }
};

// Info panel
$(document).ready(() => {
  $('.trigger, .panel').click(() => {
    $('.panel').toggle('fast');
    $('.panel').toggleClass('active');
    return false;
  });
});

const select1 = document.getElementById('select1');
const select2 = document.getElementById('select2');

select1.addEventListener('change', changeLayer, false);
select2.addEventListener('change', changeOLLayer, false);

// var rulerSize = document.getElementById('ruler-size');
// rulerSize.addEventListener("click", changeSlideRulerSize, false);

// Set the size of the peephole
function handleSize(value) {
  // console.log('Size: ' + value);
  radius = value;
  map.render();
}

// Set the transparency of the peephole
function handleTransparency(value) {
  // console.log('Transparency: ' + value);
  const layer = document.getElementById('select2').value;
  topLayersArray[layer].setOpacity(value / 10);
}

new SlideRuler(
  {
    el: document.querySelector('#ruler-size'),
    maxValue: 500,
    minValue: 20,
    currentValue: 130,
    handleValue: handleSize,
    precision: 10,
    canvasHeight: 35,
    canvasWidth: 100,
    heightDecimal: 35,
    heightDigit: 15,
    colorDecimal: '#040404',
    colorDigit: '#040404'
  }
);

const SlideRulerSize = new SlideRuler(
  {
    el: document.querySelector('#ruler-transparency'),
    maxValue: 10,
    minValue: 0,
    currentValue: 10,
    handleValue: handleTransparency,
    precision: 1,
    canvasHeight: 35,
    canvasWidth: 100,
    heightDecimal: 35,
    heightDigit: 15,
    colorDecimal: '#040404',
    colorDigit: '#040404'
  }
);

// Set the size of the peephole
// function changeSlideRulerSize(){
// console.log('changeSlideRulerSize: ' + SlideRulerSize);
// radius = SlideRulerSize.value;
// map.render();
// }

function layerswitch(evt) {
  baseLayersArray[evt.value].setVisible(evt.checked);
}

function changeLayer(evt) {
  document.getElementById('select1').blur();
  const lager = document.getElementById('select1').value;
  for (let i = 0; i < baseLayersArrayLength; i++) {
    baseLayersArray[i].setVisible(false);
  }
  baseLayersArray[lager].setVisible(true);
  // Zoom in if needed if the layer is 'Skannade detaljplaner'
  if (lager === '15' && map.getView().getZoom() < 15) {
    map.getView().setZoom(16);
  }
  // Zoom in if needed and change center if the layer is 'HistoriskKarta1642'
  if (lager === '16') {
    view.setCenter(fromLonLat(['17.31', '62.39']));
    if (map.getView().getZoom() < 16) {
      map.getView().setZoom(15);
    }
  }
  // Zoom in if needed and change center if the layer is 'HistoriskKarta1642'
  if (lager === '16') {
    view.setCenter(fromLonLat(['17.31', '62.39']));
    if (map.getView().getZoom() < 16) {
      map.getView().setZoom(15);
    }
  }
  // Zoom in if needed and change center if the layer is 'HistoriskKarta1857'
  if (lager === '17') {
    view.setCenter(fromLonLat(['17.31', '62.39']));
    if (map.getView().getZoom() < 16) {
      map.getView().setZoom(15);
    }
  }
  // Zoom in if needed and change center if the layer is 'HistoriskKarta1878'
  if (lager === '18') {
    view.setCenter(fromLonLat(['17.31', '62.39']));
    if (map.getView().getZoom() < 16) {
      map.getView().setZoom(15);
    }
  }
  // Zoom in if needed and change center if the layer is 'HistoriskKarta1910'
  if (lager === '19') {
    view.setCenter(fromLonLat(['17.31', '62.39']));
    if (map.getView().getZoom() < 16) {
      map.getView().setZoom(15);
    }
  }
  // Zoom in if needed and change center if the layer is 'HistoriskKarta1917'
  if (lager === '20') {
    view.setCenter(fromLonLat(['17.31', '62.39']));
    if (map.getView().getZoom() < 16) {
      map.getView().setZoom(15);
    }
  }
  // Zoom in if needed and change center if the layer is 'HistoriskKarta1935'
  if (lager === '21') {
    view.setCenter(fromLonLat(['17.31', '62.39']));
    if (map.getView().getZoom() < 16) {
      map.getView().setZoom(15);
    }
  }
  // Zoom in if needed and change center if the layer is 'HistoriskKarta1939'
  if (lager === '22') {
    view.setCenter(fromLonLat(['17.31', '62.39']));
    if (map.getView().getZoom() < 16) {
      map.getView().setZoom(15);
    }
  }
  // Zoom in if needed if the layer is 'Historisk karta 1952'
  if (lager === '23' && map.getView().getZoom() < 14) {
    view.setCenter(fromLonLat(['17.31', '62.39']));
    if (map.getView().getZoom() < 16) {
      map.getView().setZoom(15);
    }
  }
  // Zoom in if needed if the layer is 'EkonomiskaKartan'
  if (lager === '24' && map.getView().getZoom() < 11) {
    map.getView().setZoom(12);
  }
  // Zoom out if needed if the layer is 'Generalstabskartan'
  if (lager === '25' && map.getView().getZoom() > 15) {
    map.getView().setZoom(14);
  }
  // Zoom in if needed and change center if the layer is 'Laga skifte'
  if (lager === '26') {
    view.setCenter(fromLonLat(['17.23', '62.42']));
    if (map.getView().getZoom() < 16) {
      map.getView().setZoom(15);
    }
  }
}

function changeOLLayer(evt) {
  document.getElementById('select2').blur();
  const lager = document.getElementById('select2').value;
  for (let i = 0; i < topLayersArrayLength; i++) {
    topLayersArray[i].setVisible(false);
  }
  topLayersArray[lager].setVisible(true);
  // Zoom in if needed if the layer is 'Skannade detaljplaner'
  if (lager === '15' && map.getView().getZoom() < 15) {
    map.getView().setZoom(16);
  }
  // Zoom in if needed and change center if the layer is 'HistoriskKarta1642'
  if (lager === '16') {
    view.setCenter(fromLonLat(['17.31', '62.39']));
    if (map.getView().getZoom() < 16) {
      map.getView().setZoom(15);
    }
  }
  // Zoom in if needed and change center if the layer is 'HistoriskKarta1642'
  if (lager === '16') {
    view.setCenter(fromLonLat(['17.31', '62.39']));
    if (map.getView().getZoom() < 16) {
      map.getView().setZoom(15);
    }
  }
  // Zoom in if needed and change center if the layer is 'HistoriskKarta1857'
  if (lager === '17') {
    view.setCenter(fromLonLat(['17.31', '62.39']));
    if (map.getView().getZoom() < 16) {
      map.getView().setZoom(15);
    }
  }
  // Zoom in if needed and change center if the layer is 'HistoriskKarta1878'
  if (lager === '18') {
    view.setCenter(fromLonLat(['17.31', '62.39']));
    if (map.getView().getZoom() < 16) {
      map.getView().setZoom(15);
    }
  }
  // Zoom in if needed and change center if the layer is 'HistoriskKarta1910'
  if (lager === '19') {
    view.setCenter(fromLonLat(['17.31', '62.39']));
    if (map.getView().getZoom() < 16) {
      map.getView().setZoom(15);
    }
  }
  // Zoom in if needed and change center if the layer is 'HistoriskKarta1917'
  if (lager === '20') {
    view.setCenter(fromLonLat(['17.31', '62.39']));
    if (map.getView().getZoom() < 16) {
      map.getView().setZoom(15);
    }
  }
  // Zoom in if needed and change center if the layer is 'HistoriskKarta1935'
  if (lager === '21') {
    view.setCenter(fromLonLat(['17.31', '62.39']));
    if (map.getView().getZoom() < 16) {
      map.getView().setZoom(15);
    }
  }
  // Zoom in if needed and change center if the layer is 'HistoriskKarta1939'
  if (lager === '22') {
    view.setCenter(fromLonLat(['17.31', '62.39']));
    if (map.getView().getZoom() < 16) {
      map.getView().setZoom(15);
    }
  }
  // Zoom in if needed if the layer is 'Historisk karta 1952'
  if (lager === '23' && map.getView().getZoom() < 14) {
    view.setCenter(fromLonLat(['17.31', '62.39']));
    if (map.getView().getZoom() < 16) {
      map.getView().setZoom(15);
    }
  }
  // Zoom in if needed if the layer is 'EkonomiskaKartan'
  if (lager === '24' && map.getView().getZoom() < 11) {
    map.getView().setZoom(12);
  }
  // Zoom out if needed if the layer is 'Generalstabskartan'
  if (lager === '25' && map.getView().getZoom() > 15) {
    map.getView().setZoom(14);
  }
  // Zoom in if needed and change center if the layer is 'Laga skifte'
  if (lager === '26') {
    view.setCenter(fromLonLat(['17.23', '62.42']));
    if (map.getView().getZoom() < 16) {
      map.getView().setZoom(15);
    }
  }
}
function isInt(n) {
  return n != '' && !isNaN(n) && Math.round(n) == n;
}
function isFloat(n) {
  return n != '' && !isNaN(n) && Math.round(n) != n;
}

// Helper functions used by other pages.
(function applicationFunctions() {
  var appFunctions = {
    // * * * * * * * search functionality * * * * * * * *

    displaySearchResultFirst(data, status) {
      let searchLayer = searchLayers[0];

      appFunctions.displaySearchResult(data, status, searchLayer.layer, searchLayer.displayFields, searchLayer.geometryField, true);

      // if there is more that one search layer (we are using address and fastighet)
      if (searchLayers.length > 1) {
        searchLayer = mapLayersAndProperties.searchLayers[1];
        appFunctions.doWfsSearch(searchLayer.url, searchLayer.layer, searchLayer.searchField, $('#searchbar-input-field').val(), searchLayer.outputFormat, 'EPSG:3014', appFunctions.displaySearchResultSecond);
      }
    },

    displaySearchResultSecond(data, status) {
      const searchLayer = searchLayers[1];
      appFunctions.displaySearchResult(data, status, searchLayer.layer, searchLayer.displayFields, searchLayer.geometryField, false);
    },

    displaySearchResult(data, status, featureLayerName, displayFields, geomName, first) {
      if (status === 'success') { // will it be success if gets no data? Yes it will.
        const x2js = new X2JS();
        const jsonData = x2js.xml2json(data);
        const featureMember = jsonData.FeatureCollection.featureMember; // an array of objects. object for each feature.
        if (typeof featureMember !== 'undefined') {
          let featureCollection = new Array();
          if (typeof featureMember.length !== 'undefined') {
            featureCollection = featureMember;
          } else {
            featureCollection.push(featureMember); // Om vi bara fÃ¥r ett sÃ¶kresultat sÃ¥ Ã¤r featureMember inte en array
          }

          // carry on the original if statement here.
          const options = new Array();

          for (i = 0; i < featureCollection.length; i++) {
            const feature = featureCollection[i];
            var attributes = feature[featureLayerName];
            const geo = attributes[geomName];

            let wktGeom = '';
            if (typeof geo.Point !== 'undefined') {
              wktGeom = `POINT (${geo.Point.coordinates.__text.split(',').join(' ')})`;
            } else if (typeof geo.Polygon !== 'undefined') {
              wktGeom = `POLYGON ((${geo.Polygon.outerBoundaryIs.LinearRing.coordinates.__text.split(',').join(';').split(' ').join(',')
                .split(';')
                .join(' ')}))`;
            }

            // display fields was passed as a param to displaySearchResult - it's the layer.displayFields property. ["sok"]
            var attributeValue = '';
            displayFields.forEach((element) => { // element will for example be "sok"
              if (attributeValue.length > 0) {
                attributeValue += ', ';
              }
              attributeValue += attributes[element].__text;
            });

            // LÃ¤gga vÃ¤rden i array och sortera innan de lÃ¤ggs till dropdownbox
            options.push({
              value: wktGeom,
              text: attributeValue
            });
          }

          // sort
          if (options.length > 1) {
            options.sort((ao, bo) => {
              let a; let b; let a1; let b1; let i = 0; let n; let L;
              const rx = /(\.\d+)|(\d+(\.\d+)?)|([^\d.]+)|(\.\D+)|(\.$)/g;
              const as = ao.text;
              const bs = bo.text;
              if (as === bs) return 0;
              a = as.toLowerCase().match(rx);
              b = bs.toLowerCase().match(rx);
              L = a.length;
              while (i < L) {
                if (!b[i]) return 1;
                a1 = a[i],
                b1 = b[i++];
                if (a1 !== b1) {
                  n = a1 - b1;
                  if (!isNaN(n)) return n;
                  return a1 > b1 ? 1 : -1;
                }
              }
              return b[i] ? -1 : 0;
            });
          }

          // make sure the dropdown is cleared out
          if (first) {
            $('#search-results-adress').empty();
          } else {
            $('#search-results-fastigheter').empty();
          }

          // add the results to the dropdown.

          options.forEach((element) => {
            if (first) { // if it's the first search layer (adress)
              // show the result count
              // document.getElementById("adress-result-count").innerHTML = "(" + options.length + " resultat" + ")";

              // add the results to the select box
              $('#search-results-adress').append($('<option></option>', {
                value: element.value,
                text: element.text
              }));
            } else {
              // show the result count
              // document.getElementById("fastighet-result-count").innerHTML = "(" + options.length + " resultat" + ")";

              $('#search-results-fastigheter').append($('<option></option>', {
                value: element.value,
                text: element.text
              }));
            }
          });
        }
        const adressCount = document.getElementById('search-results-adress').length;
        const fastighetCount = document.getElementById('search-results-fastigheter').length;
        document.getElementById('adress-result-count').innerHTML = `(${adressCount} stycken` + ')';
        document.getElementById('fastighet-result-count').innerHTML = `(${fastighetCount} stycken` + ')';
      }
    },

    doWfsSearch(url, layer, propertyName, propertyValue, outputFormat, projection, resultFunction) {
      let str = "<wfs:GetFeature service = 'WFS' version = '1.1.0' xmlns:wfs = 'http://www.opengis.net/wfs' xmlns:ogc = 'http://www.opengis.net/ogc' xmlns:gml = 'http://www.opengis.net/gml' xmlns:esri = 'http://www.esri.com' xmlns:xsi = 'http://www.w3.org/2001/XMLSchema-instance' xsi:schemaLocation='http://www.opengis.net/wfs ../wfs/1.1.0/WFS.xsd'";
      str = `${str} outputFormat="${outputFormat}" maxFeatures="1000">`;
      str = `${str}<wfs:Query typeName='feature:${layer}' srsName='${projection}'>`;
      const prop = `<ogc:PropertyIsLike matchCase="false" wildCard="*" singleChar="." escapeChar="!"><ogc:PropertyName>${propertyName}</ogc:PropertyName><ogc:Literal>${propertyValue}*</ogc:Literal></ogc:PropertyIsLike>`;
      str = `${str}<ogc:Filter>${prop}</ogc:Filter></wfs:Query></wfs:GetFeature>`;

      $.ajax({
        url,
        contentType: 'text/xml',
        crossDomain: true,
        type: 'post',
        data: str,
        success: resultFunction // run this function when the ajax response is successfully recieved. //displaySearchResultFirst
      });
    },

    searchValueChanged(event) {
      const searchValue = event.target.value;

      if (searchValue.length < 4) {
        // make sure the results are empty.
        $('#search-results-adress').empty();
        $('#search-results-fastigheter').empty();

        // set search stuff to hidden.

        // reset the result counts.
        document.getElementById('adress-result-count').innerHTML = '';
        document.getElementById('fastighet-result-count').innerHTML = '';
      }
      if (searchValue.length > 3) {
        // make sure the search is showing.
        document.getElementById('search-results-list').style.display = 'block';

        $('#searchbar-input-field-clear').removeAttr('hidden'); // make the close button appear
        $('#search-results-area').removeAttr('hidden'); // make the search results area appear

        $('#search-results-adress').on('change', appFunctions.searchResultsChanged);
        $('#search-results-fastigheter').on('change', appFunctions.searchResultsChanged);

        const searchLayer = mapLayersAndProperties.searchLayers[0]; // adress search
        appFunctions.doWfsSearch(searchLayer.url, searchLayer.layer, searchLayer.searchField, searchValue, searchLayer.outputFormat, 'EPSG:3007', appFunctions.displaySearchResultFirst);
      }
    },

    searchResultsChanged(e) { // change event as input
      // g_search_layer is the general openlayers vetor layer that was created and added to the map.
      baseSearchLayer.getSource().clear();

      // check whether the adress select box or the fastigheter select box has changed.
      if (e.target === document.getElementById('search-results-adress')) {
        var selectedResultGeom = $('#search-results-adress option:selected').val();
      }

      if (e.target === document.getElementById('search-results-fastigheter')) {
        var selectedResultGeom = $('#search-results-fastigheter option:selected').val();
      }

      if (typeof selectedResultGeom !== 'undefined') {
        const formatWKT = new ol.format.WKT();

        // add feature to the layer and zoom to feature
        baseSearchLayer.getSource().addFeature(formatWKT.readFeature(selectedResultGeom));
        const feature = baseSearchLayer.getSource().getFeatures()[0];
        const extent = feature.getGeometry().getExtent();

        // put in the if statement because of sida-vid-sida which used map1, map2, map3, map4
        if (typeof map !== 'undefined') {
          map.getView().fit(extent, { size: map.getSize(), maxZoom: 7 });
        } else if (map1) {
          map1.getView().fit(extent, { size: map1.getSize(), maxZoom: 7 });
        }
      }
    },

    clearSearch() {
      // clear the adress/fastighet object
      baseSearchLayer.getSource().clear();

      // clear the search results
      $('#search-results-adress').empty();
      $('#search-results-fastigheter').empty();

      // hide the search results stuff
      document.getElementById('search-results-area').hidden = true;

      // clear out the search input bar
      document.getElementById('searchbar-input-field').value = '';

      // hide the search close button
      document.getElementById('searchbar-input-field-clear').hidden = true;

      // clear the result counts
      document.getElementById('adress-result-count').innerHTML = '';
      document.getElementById('fastighet-result-count').innerHTML = '';

      // make sure that toggleSearchResults is on "DÃ¶lj"
      document.getElementById('result-hide-text').textContent = 'DÃ¶lj';
      if (document.getElementById('result-hide-symbol').classList.contains('fa-angle-down')) {
        document.getElementById('result-hide-symbol').classList.replace('fa-angle-down', 'fa-angle-up');
      }
    },

    toggleSearchResults() {
      // change the inner HTML of the DÃ¶jl/Visa and the class of the up/down arrow.
      if (document.getElementById('result-hide-text').textContent === 'DÃ¶lj') {
        document.getElementById('result-hide-text').textContent = 'Visa';
        document.getElementById('result-hide-symbol').classList.replace('fa-angle-up', 'fa-angle-down');
        document.getElementById('search-results-list').style.display = 'none';
      } else if (document.getElementById('result-hide-text').textContent === 'Visa') {
        document.getElementById('result-hide-text').textContent = 'DÃ¶lj';
        document.getElementById('result-hide-symbol').classList.replace('fa-angle-down', 'fa-angle-up');
        document.getElementById('search-results-list').style.display = 'block';
      }
    },

    setSearchEventListeners() {
      const searchInput = document.getElementById('searchbar-input-field');
      searchInput.addEventListener('input', appFunctions.searchValueChanged);

      const searchCloser = document.getElementById('searchbar-input-field-clear');
      searchCloser.addEventListener('click', appFunctions.clearSearch);

      const searchToggler = document.getElementById('search-results-toggle');
      searchToggler.addEventListener('click', appFunctions.toggleSearchResults);
    }
  };

  // create appFunctions object as a global variable.
  window.appFunctions = appFunctions;
}());
